import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { IntegrationSettings } from './types';

export function useIntegrationSettings(rootfiCompanyId: number, corporationId: number) {
  const { data, error, isLoading, mutate } = useSWR<IntegrationSettings>(
    rootfiCompanyId ? `rootfi/${rootfiCompanyId}/settings?corporationId=${corporationId}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    settings: data,
    error,
    mutate,
    isLoading,
  };
}
